import { IpayAfrica } from './_ipay';

export default (order, callback) => {

  const ipay = new IpayAfrica(true);

  const { last_name, first_name, order_id, email_address, phone_no,amount } = order;

  const request = {
    amount: amount,
    order_id: order_id,
    telephone: phone_no,
    email: email_address,
    last_name: last_name,
    first_name: first_name,
    param1: order.ref,
    param2: order.cid
  };

  return ipay.post(request, callback);

}
